
export default {
    analytics: {
        analyticsData: {},
        isAnalyticsDataLoadedSuccessfully: false,
    },
    apiStatus: {
        apiCallsInProgress: 0,
        apiErrorMessages: []
    }
};
